<template>
  <v-dialog
    v-model="dialog"
    width="600"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span v-text="$t('labels.confirmRequest')" />
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>{{ mdiClose }}</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text
        v-if="message"
        class="pa-3 text-center text-subtitle-1"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="message" />
      </v-card-text>
      <v-card-text v-else>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col
            cols="12"
            sm="8"
            offset="2"
            md="4"
            offset-md="4"
          >
            <v-btn
              block
              depressed
              :color="buttonColor"
              @click="confirm"
            >
              <span v-text="$t('labels.confirm')" />
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'BaseModalConfirmAction',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: '',
      note: 'The modal message',
    },
    buttonColor: {
      type: String,
      default: 'primary',
      note: 'The confirm button color',
    },
  },
  emits: ['input', 'confirm'],
  data() {
    return { mdiClose };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      this.dialog = false;
    },
  },
};
</script>
